import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Trabajo from './views/Trabajo.vue'
import Gracias from './views/Gracias.vue'
import Pruebas from './views/Pruebas.vue'

import store from './store'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/pruebas',
      name: 'Pruebas',
      component: Pruebas,
      props: false
    },
    {
      path: '/contacto',
      name: 'Contacto',
      component: Home,
      props: false,
      beforeEnter (to, from, next) {
        store.commit('goToSection', 5)
        next('/')
      }
    },
    {
      path: '/contacto/gracias',
      name: 'Gracias',
      component: Gracias,
      props: false,
      beforeEnter (to, from, next) {
        if (store.state.graciasView) {
          window.gtag('event', 'conversion', { 'send_to': 'AW-11025123416/Z3NBCLOzm90YENiQmIkp' })
          next()
        } else {
          next('/')
        }
      }
    },
    {
      path: '/:section?',
      name: 'home',
      component: Home,
      beforeEnter: (to, from, next) => {
        if (to.params.section) {
          if (['reels'].indexOf(to.params.section) > -1) {
            next()
          } else {
            next('/')
          }
        } else {
          next()
        }
      }
    },
    {
      path: '/trabajos/:workName',
      name: 'Trabajo',
      component: Trabajo,
      props: true
    }
  ]
})
